import { devToolsSections } from './devToolsSections'
import { SidebarCard } from './styled-components'
import { useTranslation } from 'react-i18next'
import SidebarItem from '@/containers/DevToolsNew/DevToolsLayout/DevToolsSidebarItem'


const DevToolsSidebar = () => {
  const { t } = useTranslation('devToolsNew')
  return (
    <SidebarCard>
      {devToolsSections.map(({ key, labelKey, Icon }) => (
        <SidebarItem key={key} to={`/dev-tools-v2/${key}`} label={t(labelKey)} Icon={Icon} />
      ))}
    </SidebarCard>
  )
}

export default DevToolsSidebar
